import { logout } from "@/auth";

import { Button } from "@/components/ui/button";

// Styles Constants based on Figma Design
const STYLES = {
  heading: {
    fontSize: "20px",
    lineHeight: "20px",
    color: "#002248"
  },
  successMessage: {
    fontSize: "15px",
    lineHeight: "40px",
    color: "#057C11"
  },
  button: {
    width: "108px",
    height: "32px",
    padding: "7px 0",
    background: "#057C11",
    boxShadow: "0px 10px 10px rgba(0, 0, 0, 0.25)",
    fontSize: "15px",
    lineHeight: "15px",
    color: "#FFF8F8",
    borderRadius: "4px"
  }
} as const;

interface PasswordResetSuccessProps {
  onConfirm?: () => void;
}

const PasswordResetSuccess = ({ onConfirm }: PasswordResetSuccessProps) => {
  const handleConfirm = () => {
    // Call onConfirm if provided
    if (onConfirm) {
      onConfirm();
    }

    // Logout user and redirect to login page
    logout();
  };

  return (
    <div className="w-full space-y-8 sm:space-y-10">
      {/* Title */}
      <div className="space-y-6">
        <h2
          className="flex justify-center text-center font-bold"
          style={STYLES.heading}
        >
          بازیابی رمز عبور جدید
        </h2>

        {/* Success Message */}
        <div className="px-4">
          <p
            className="flex items-center justify-center text-center"
            style={STYLES.successMessage}
          >
            رمز عبور شما با موفقیت تغییر یافت.
          </p>
          <p>
            اکنون می‌توانید با رمز جدید وارد{" "}
            <a href="/" className="text-blue-500">
              سامانه
            </a>{" "}
            شوید.
          </p>
        </div>
      </div>

      {/* Confirm Button */}
      <div className="flex justify-end">
        <Button
          onClick={handleConfirm}
          className="flex items-center justify-center font-normal transition-opacity hover:opacity-90"
          style={STYLES.button}
        >
          تایید
        </Button>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;
